import React from 'react';
import { motion } from 'framer-motion';
import { Star, BadgeCheck } from 'lucide-react';
const testimonials = [{
  quote: "J'avais jamais jardiné de ma vie. En 3 semaines j'avais mes premières tomates cerises sur mon balcon à Montréal. Le guide est tellement simple à suivre que même mes enfants participent maintenant.",
  name: 'Jean-Philippe R.',
  location: 'Montréal',
  badge: '✅ Acheté il y a 5 jours',
  initials: 'JP'
}, {
  quote: "Je dépensais 80€ par mois en herbes fraîches à l'épicerie. Ça fait 6 semaines que je n'ai plus acheté de basilic ni de coriandre. Sur 2m² de balcon à Paris. Pour 9,97€ c'est ridicule comme investissement.",
  name: 'Marie-Laure D.',
  location: 'Paris',
  badge: '✅ Achetée il y a 8 jours',
  initials: 'ML'
}, {
  quote: "J'ai une seule fenêtre côté sud dans mon appartement à Granby. J'étais sceptique. Aujourd'hui j'ai 4 variétés de salades et des radis qui poussent sur mon rebord de fenêtre. Le calendrier de semis inclus est génial.",
  name: 'Sophie T.',
  location: 'Granby',
  badge: '✅ Achetée il y a 12 jours',
  initials: 'ST'
}];
export function Testimonials() {
  return <section className="bg-white py-20 md:py-24 px-6" data-id="element-141">
      <div className="max-w-[1100px] mx-auto" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-143">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-forest mb-3" data-id="element-144">
            Ce que disent nos clients <span className="inline-block" data-id="element-145">🌱</span>
          </h2>
          <p className="font-sans text-charcoal/60 text-base md:text-lg" data-id="element-146">
            Des centaines de familles ont déjà adopté le système
          </p>
          <div className="h-1 w-20 bg-accent mx-auto rounded-full mt-6" data-id="element-147"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-148">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white rounded-2xl shadow-md hover:shadow-xl border border-cream-dark/60 p-6 md:p-7 flex flex-col transition-shadow duration-300" data-id="element-149">
              {/* Stars */}
              <div className="flex gap-0.5 mb-4" data-id="element-150">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-accent text-accent" data-id="element-151" />)}
              </div>

              {/* Quote */}
              <p className="font-serif text-charcoal text-base md:text-lg leading-relaxed italic flex-grow mb-6" data-id="element-152">
                "{t.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-cream-dark/60" data-id="element-153">
                <div className="w-11 h-11 rounded-full bg-forest text-cream flex items-center justify-center font-sans font-bold text-sm flex-shrink-0" data-id="element-154">
                  {t.initials}
                </div>
                <div className="flex-1 min-w-0" data-id="element-155">
                  <p className="font-sans font-bold text-charcoal text-sm" data-id="element-156">
                    {t.name}
                  </p>
                  <p className="font-sans text-charcoal/60 text-xs" data-id="element-157">
                    {t.location}
                  </p>
                </div>
              </div>

              {/* Verified badge */}
              <div className="mt-4 inline-flex items-center gap-1.5 self-start bg-forest/10 text-forest text-xs font-sans font-semibold px-3 py-1 rounded-full" data-id="element-158">
                <BadgeCheck className="w-3.5 h-3.5" data-id="element-159" />
                <span data-id="element-160">{t.badge.replace('✅ ', '')}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}